/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-restricted-globals */
import React, { useEffect, useLayoutEffect } from 'react';
import { get } from 'lodash';
import { useBreadcrumb } from '../../../../../app/contexts/BreadcrumbContext';
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from '../../../_core/MetronicSubheader';
import { BreadCrumbs } from '../../subheader/components/BreadCrumbs';

function HeaderMenu({ layoutProps }) {
  const subheader = useSubheader();
  const { paths } = useBreadcrumb();

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle('kt_aside_menu', location.pathname);
    const header = getBreadcrumbsAndTitle('kt_header_menu', location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {}, [subheader]);

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li className="menu-item">
          <div className="d-flex align-items-baseline mr-5">
            <h5 className="text-dark font-weight-bold my-2 mr-5">
              {get(paths, '[0].title', '')}
            </h5>
          </div>
          <BreadCrumbs paths={paths} />
        </li>
      </ul>
    </div>
  );
}
export default HeaderMenu;
